// These are the rules by which the form input fields will be checked against.

import { formHasErrors, formHasValue, setFormValues } from "./objectValidation";

/**
 * Criteria:
 * 1) Required
 */
const firstNameValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "first_name", true, "Required");
    }

    return setFormValues(row, "first_name", false, "");
};

/**
 * Criteria:
 * 1) Required
 */
const lastNameValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "last_name", true, "Required");
    }

    return setFormValues(row, "last_name", false, "");
};

// The main constant, directing to the specific validation function.
export const AUTHOR_VALIDATION = {
    first_name: {
        check: firstNameValidation
    },
    last_name: {
        check: lastNameValidation
    }
};

export const IS_AUTHOR_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "last_name");
};
